(ns frontend.logging
  (:require
   [clojure.string :as string]
   [common.dates :as d]))

(defonce log-atom (atom {}))

(defn print-debug?
  []
  (boolean (:print-debug? @log-atom)))

(defn update-print-debug!
  [print?]
  (swap! log-atom assoc :print-debug? print?))

(defn debug-time
  []
  (d/format (js/Date.)
            {:pattern "HH:mm:ss.SSS"}))

(defn debug
  [& args]
  (when (print-debug?)
    (js/console.log (debug-time) (string/join " " args))))

(defn log
  [& args]
  (js/console.log args))

(defn info
  [& args]
  (js/console.info " " args))

(defn warn
  [& args]
  (js/console.warn " " args))

(defn error
  [& args]
  (js/console.error args))

(defn unimplemented
  [& args]
  (js/console.log "UNIMPLEMENTED: " (string/join " " args)))

(defn performance
  [& args]
  (js/console.log (str (js/Date.) ":PERF: ") args))
